import { useEffect, useRef } from 'react';
import { OptionsHeading } from '../EditorConditionFieldOptions';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import EditorFieldOption from '../EditorFieldOption';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { HR } from 'foundations-components/transitional/components/HR';
import { Section } from 'foundations-components/transitional/components/Section';
import { useSuggestedProperties } from './useSuggestedProperties';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PropertySearchSuggestionsComponent = props => {
  const {
    filterFamily,
    searchString,
    hiddenProperties,
    onSelectField,
    suggestedPropertiesResultsRef,
    onLayoutMayHaveChanged,
    useDataExplorerStyling
  } = props;
  const {
    options,
    loading,
    error
  } = useSuggestedProperties({
    searchString,
    filterFamily,
    hiddenProperties
  });
  const prevLoading = useRef();
  const prevOptionsLength = useRef();
  useEffect(() => {
    if (suggestedPropertiesResultsRef) {
      suggestedPropertiesResultsRef.current = options;
    }
    const currentOptionsLength = options ? options.length : 0;
    if (prevOptionsLength.current !== currentOptionsLength) {
      onLayoutMayHaveChanged === null || onLayoutMayHaveChanged === void 0 || onLayoutMayHaveChanged();
    }
    prevOptionsLength.current = currentOptionsLength;
  }, [options, suggestedPropertiesResultsRef, onLayoutMayHaveChanged]);
  useEffect(() => {
    if (prevLoading.current !== undefined && prevLoading.current !== loading) {
      onLayoutMayHaveChanged === null || onLayoutMayHaveChanged === void 0 || onLayoutMayHaveChanged();
    }
    prevLoading.current = loading;
  }, [loading, onLayoutMayHaveChanged]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(OptionsHeading, {
      children: /*#__PURE__*/_jsx(TruncateString, {
        paddingInlineStart: useDataExplorerStyling ? '400' : undefined,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "newCustomerDataFilters.fieldSelectFlow.recommendedProperties"
        })
      })
    }), loading && /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true,
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "newCustomerDataFilters.fieldSelectFlow.loadingRecommendedProperties"
      }),
      showLabel: true,
      size: "small"
    }), !loading && (error || !options || !options.length) && /*#__PURE__*/_jsx(Section, {
      paddingInlineStart: "200",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "newCustomerDataFilters.fieldSelectFlow.noRecommendedProperties"
      })
    }), options && options.map(property => {
      return /*#__PURE__*/_jsx(EditorFieldOption, {
        field: property,
        filterFamily: filterFamily,
        onClick: () => onSelectField(property, true)
      }, property.label);
    }), /*#__PURE__*/_jsx(HR, {
      distance: "extra-small"
    })]
  });
};